import { render, staticRenderFns } from "./RestaurantSubscriptionAndBilling.vue?vue&type=template&id=72482e5c&"
import script from "./RestaurantSubscriptionAndBilling.vue?vue&type=script&lang=js&"
export * from "./RestaurantSubscriptionAndBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports